import React from "react";

// Add/remove/reorder editor for a plain string[] field (heroHighlights,
// overviewDescription, and each requirementGroup's items).
export default function StringListEditor(props: {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
}) {
  const { values, onChange } = props;

  function update(index: number, value: string) {
    const next = [...values];
    next[index] = value;
    onChange(next);
  }

  function remove(index: number) {
    onChange(values.filter((_, i) => i !== index));
  }

  function move(index: number, dir: -1 | 1) {
    const target = index + dir;
    if (target < 0 || target >= values.length) return;
    const next = [...values];
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  }

  return (
    <div className="mb-4">
      <span className="block text-sm text-secondary-dark mb-1.5">{props.label}</span>
      <div className="flex flex-col gap-2">
        {values.map((value, index) => (
          <div key={index} className="flex items-center gap-2">
            <input
              type="text"
              value={value}
              placeholder={props.placeholder}
              onChange={(e) => update(index, e.target.value)}
              className="flex-1 border border-fourth-light rounded-lg px-3 py-1.5 text-sm outline-none focus:border-gold transition-colors bg-white"
            />
            <button type="button" onClick={() => move(index, -1)} className="text-secondary-light hover:text-gold px-1" title="上移">↑</button>
            <button type="button" onClick={() => move(index, 1)} className="text-secondary-light hover:text-gold px-1" title="下移">↓</button>
            <button type="button" onClick={() => remove(index)} className="text-red-400 hover:text-red-600 px-1" title="删除">✕</button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={() => onChange([...values, ""])}
        className="mt-2 text-xs text-gold hover:text-secondary-dark transition-colors"
      >
        + 添加一项
      </button>
    </div>
  );
}
